(function () {
  var heroBtn = document.querySelector(".hero-btn");
  if (heroBtn && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      document.body.classList.toggle("hero-cta-visible", entries[0].isIntersecting);
    }, { threshold: 0 }).observe(heroBtn);
  }

  var configurator = document.getElementById("configurator");
  if (configurator && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      document.body.classList.toggle("hide-mobile-cta", entries[0].isIntersecting);
    }, { threshold: 0 }).observe(configurator);
  }

  var support = document.getElementById("support");
  if (support && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      document.body.classList.toggle("support-cta-visible", entries[0].isIntersecting);
    }, { threshold: 0 }).observe(support);
  }

  var video = document.getElementById("edgerVid");
  if (video && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    video.removeAttribute("autoplay");
    if (video.pause) {
      try {
        video.pause();
      } catch (error) {
      }
    }
  }
})();

function toggleFaq(btn) {
  var item = btn.parentElement;
  var open = item.classList.toggle("open");
  btn.setAttribute("aria-expanded", open ? "true" : "false");
}

function openSupportForm(source) {
  var modal = document.getElementById("supportForm");
  if (!modal) return;
  var sourceField = modal.querySelector('input[name="source"]');
  if (sourceField) {
    sourceField.value = source === "configurator_sidebar"
      ? "configurator_sidebar"
      : "front_page";
  }
  modal.hidden = false;
  document.body.style.overflow = "hidden";
  var firstField = modal.querySelector('input[name="name"]');
  if (firstField) firstField.focus();
}

function closeSupportForm() {
  var modal = document.getElementById("supportForm");
  if (!modal) return;
  modal.hidden = true;
  document.body.style.overflow = "";
  var body = document.getElementById("supFormBody");
  var done = document.getElementById("supFormDone");
  if (body) body.hidden = false;
  if (done) done.hidden = true;
  var form = modal.querySelector(".sup-form");
  if (form && form.reset) form.reset();
  var sourceField = form && form.querySelector('input[name="source"]');
  if (sourceField) sourceField.value = "front_page";
  var error = form && form.querySelector(".sup-form__error");
  if (error) {
    error.hidden = true;
    error.textContent = "";
  }
  if (window.turnstile && typeof window.turnstile.reset === "function") {
    try { window.turnstile.reset(); } catch (turnstileError) {}
  }
  supFileName({ files: null });
}

async function submitSupportForm(event) {
  event.preventDefault();
  var form = event.currentTarget;
  if (form.dataset.submitting === "true") return false;
  form.dataset.submitting = "true";
  var submit = form.querySelector('.sup-form__send[type="submit"]');
  var error = form.querySelector(".sup-form__error");
  var idempotencyField = form.querySelector('input[name="idempotencyKey"]');
  var attachment = form.querySelector('input[name="photo"]');
  if (attachment && attachment.files && attachment.files[0] && attachment.files[0].size > 8 * 1024 * 1024) {
    if (error) {
      error.textContent = form.dataset.photoErrorLabel || form.dataset.errorLabel;
      error.hidden = false;
    }
    form.dataset.submitting = "false";
    return false;
  }
  if (idempotencyField && !idempotencyField.value) {
    idempotencyField.value = window.crypto && typeof window.crypto.randomUUID === "function"
      ? window.crypto.randomUUID()
      : "support-" + Date.now() + "-" + Math.random().toString(36).slice(2);
  }
  if (error) {
    error.hidden = true;
    error.textContent = "";
  }
  if (submit) {
    submit.disabled = true;
    submit.textContent = form.dataset.sendingLabel || "Sending…";
  }
  try {
    var data = new FormData(form);
    data.set("turnstileToken", String(data.get("cf-turnstile-response") || ""));
    var response = await fetch(form.dataset.endpoint, {
      method: "POST",
      body: data,
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });
    var payload = await response.json().catch(function () { return {}; });
    if (!response.ok || !payload.ok) throw new Error(payload.code || "submission_failed");
    var body = document.getElementById("supFormBody");
    var done = document.getElementById("supFormDone");
    if (body) body.hidden = true;
    if (done) done.hidden = false;
    return false;
  } catch (submissionError) {
    if (error) {
      error.textContent = form.dataset.errorLabel || "We could not send your message. Please try again.";
      error.hidden = false;
      error.focus && error.focus();
    }
    if (window.turnstile && typeof window.turnstile.reset === "function") {
      try { window.turnstile.reset(); } catch (turnstileError) {}
    }
  } finally {
    form.dataset.submitting = "false";
    if (submit) {
      submit.disabled = false;
      submit.textContent = form.dataset.submitLabel || "Send";
    }
  }
  return false;
}

function supFileName(input) {
  var target = document.getElementById("supFileTxt");
  if (!target) return;
  target.textContent = input && input.files && input.files[0]
    ? input.files[0].name
    : target.dataset.defaultLabel || "";
}

document.addEventListener("keydown", function (event) {
  if (event.key !== "Escape") return;
  var modal = document.getElementById("supportForm");
  if (modal && !modal.hidden) closeSupportForm();
});

function toggleMenu(btn) {
  var menu = document.getElementById("mobileMenu");
  if (!menu) return;
  var open = menu.classList.toggle("open");
  btn.setAttribute("aria-expanded", open ? "true" : "false");
}

function closeMenu() {
  var menu = document.getElementById("mobileMenu");
  var button = document.querySelector(".hamburger");
  if (menu) menu.classList.remove("open");
  if (button) button.setAttribute("aria-expanded", "false");
}
